export const name = "JUSTIFY_INTERVAL";
export const summary = `Normalizes the day and time parts of an \`INTERVAL\` value.`;
export const reference = `
## JUSTIFY_INTERVAL

Normalizes the day and time parts of an \`INTERVAL\` value.

\`\`\`
JUSTIFY_INTERVAL(interval_expression)
\`\`\`

### Description

Normalizes the days and time parts of the interval.


### Return Data Type

\`INTERVAL\`


### Example



\`\`\`
SELECT JUSTIFY_INTERVAL(INTERVAL '29 49:00:00' DAY TO SECOND) AS i

/*-------------*
 | i |
 +-------------+
 | 0-1 1 1:0:0 |
 *-------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/interval_functions
`;
